"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatePlan = CalculatePlan;
exports.CalculatePlanMessage = CalculatePlanMessage;
var _lodash = require("lodash");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../middleware/utils");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _Sailboat = _interopRequireDefault(require("./svg/Sailboat"));
var _House = _interopRequireDefault(require("./svg/House"));
var _BarUpChart = _interopRequireDefault(require("./svg/BarUpChart"));
var _Shield = _interopRequireDefault(require("./svg/Shield"));
var _Strategy = _interopRequireDefault(require("./svg/Strategy"));
var _ThumbsUp = _interopRequireDefault(require("./svg/ThumbsUp"));
var _Graduate = _interopRequireDefault(require("./svg/Graduate"));
var _HandsDollarSign = _interopRequireDefault(require("./svg/HandsDollarSign"));
var _AlertIcon = _interopRequireDefault(require("./svg/AlertIcon"));
var _InfoIconOrange = _interopRequireDefault(require("./svg/InfoIconOrange"));
var _FPCTModals = require("./FPCTModals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var iconComponents = {
  Sailboat: /*#__PURE__*/_react.default.createElement(_Sailboat.default, null),
  BarUpChart: /*#__PURE__*/_react.default.createElement(_BarUpChart.default, null),
  House: /*#__PURE__*/_react.default.createElement(_House.default, null),
  Shield: /*#__PURE__*/_react.default.createElement(_Shield.default, null),
  Strategy: /*#__PURE__*/_react.default.createElement(_Strategy.default, null),
  ThumbsUp: /*#__PURE__*/_react.default.createElement(_ThumbsUp.default, null),
  Graduate: /*#__PURE__*/_react.default.createElement(_Graduate.default, null),
  HandsDollarSign: /*#__PURE__*/_react.default.createElement(_HandsDollarSign.default, null),
  AlertIcon: /*#__PURE__*/_react.default.createElement(_AlertIcon.default, null)
};
function CalculatePlan(_ref) {
  var {
    values,
    setModalOpen,
    columnType,
    setFieldValue
  } = _ref;
  var goalArray = [];
  var goalDataArray = [];
  var masterAdditionalSolutions = [];
  (0, _react.useEffect)(() => {
    setFieldValue('goalDataArray', goalDataArray);
  }, []);

  // Common structure of goal solutions
  var CommonGoalStructure = _ref2 => {
    var {
      iconForGoal,
      goalName,
      columnType,
      solutions,
      additionalSolutions
    } = _ref2;
    var IconComponent = iconComponents[iconForGoal] || null;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-4 col-lg-2"
    }, IconComponent), /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, /*#__PURE__*/_react.default.createElement("h5", {
      className: "solutions-margin-top-tiny-increase"
    }, goalName))), /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-sm-4 col-lg-2"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "col"
    }, columnType === 'current' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "eyebrow solutions-title"
    }, "Your Solutions"), solutions.length === 0 ? /*#__PURE__*/_react.default.createElement("div", {
      className: "mm-spacing--minor"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "col-auto"
    }, /*#__PURE__*/_react.default.createElement(_InfoIconOrange.default, null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "col no-padding"
    }, "You didn't select any products or services that align with this goal."))) : solutions.map((solution, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-check-green margin-right-by-one"
    }), /*#__PURE__*/_react.default.createElement("span", null, solution.name)))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, solutions.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "eyebrow solutions-title"
    }, "Your Solutions"), solutions.map((solution, index) => /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "icon-check-green margin-right-by-one"
    }), /*#__PURE__*/_react.default.createElement("a", {
      target: "_self",
      href: "#",
      onClick: event => {
        event.preventDefault();
        solution.modalOpenHandler(true);
      },
      "data-bp-link": "default"
    }, solution.name)))), additionalSolutions.length > 0 && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "eyebrow solutions-title"
    }, "Opportunities to explore"), /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-style-inside"
    }, additionalSolutions.map((solution, index) => /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      onClick: event => {
        event.preventDefault();
        solution.modalOpenHandler(true);
      },
      "data-bp-link": "default"
    }, solution.name), solution.modalComponent))))))));
  };
  var renderGoal = function renderGoal(goalName, iconForGoal, solutions) {
    var additionalSolutions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    return /*#__PURE__*/_react.default.createElement("div", {
      key: goalName
    }, /*#__PURE__*/_react.default.createElement(CommonGoalStructure, {
      iconForGoal: iconForGoal,
      goalName: goalName,
      solutions: solutions,
      additionalSolutions: additionalSolutions,
      columnType: columnType
    }));
  };
  var solutions = [{
    name: 'Investment solutions',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'investmentSolutionsPlanningForRetirementModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.investmentSolutionsRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsRetirementOpen
    })
  }, {
    name: 'Investment solutions',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'investmentSolutionsSaveForMajorPurchaseModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.investmentSolutionsMajorPurchase(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForMajorPurchase, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsMajorPurchaseClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsMajorPurchaseOpen
    })
  }, {
    name: 'Investment solutions',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'investmentSolutionsBuildWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.investmentSolutionsWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsWealthOpen
    })
  }, {
    name: 'Investment solutions',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'investmentSolutionsEducationalExpensesModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.investmentSolutionsEducation(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.InvestmentSolutionsModalForEducation, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsEducationClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.investmentSolutionsEducationOpen
    })
  }, {
    name: 'Retirement accounts',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'retirementAccountsPlanningForRetirementModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.retirementAccountsRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.RetirementAccountsModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.retirementAccountsRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.retirementAccountsRetirementOpen
    })
  }, {
    name: 'Retirement accounts',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'retirementAccountsBuildWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.retirementAccountsWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.RetirementAccountsModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.retirementAccountsWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.retirementAccountsWealthOpen
    })
  }, {
    name: 'Annuities',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'annuitiesPlanningForRetirementhModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.annuitiesRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesRetirementOpen
    })
  }, {
    name: 'Annuities',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'annuitiesBuildWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.annuitiesWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesWealthOpen
    })
  }, {
    name: 'Annuities',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'annuitiesEnsureFamilySecuredModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.annuitiesFamilySecured(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.AnnuitiesModalForFamilySecured, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesFamilySecuredClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.annuitiesFamilySecuredOpen
    })
  }, {
    name: 'Life insurance',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'lifeInsurancePlanningForRetirementModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.lifeInsuranceRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceRetirementOpen
    })
  }, {
    name: 'Life insurance',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'lifeInsuranceTransitioningWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.lifeInsuranceTransitioningWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForTransitioningWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceTransitioningWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceTransitioningWealthOpen
    })
  }, {
    name: 'Life insurance',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'lifeInsuranceEducationalExpensesModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.lifeInsuranceEducation(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForEducation, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceEducationClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceEducationOpen
    })
  }, {
    name: 'Life insurance',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'lifeInsuranceEnsureFamilySecuredModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.lifeInsuranceFamilySecured(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LifeInsuranceModalForFamilySecured, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceFamilySecuredClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.lifeInsuranceFamilySecuredOpen
    })
  }, {
    name: 'Long term care protection',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'longTermCarePlanningForRetirementModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.longTermCareRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LongTermCareProtectionModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.longTermCareRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.longTermCareRetirementOpen
    })
  }, {
    name: 'Long term care protection',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'longTermCareEnsureFamilySecuredModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.longTermCareFamilySecured(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.LongTermCareProtectionModalForFamilySecured, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.longTermCareFamilySecuredClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.longTermCareFamilySecuredOpen
    })
  }, {
    name: 'Health savings accounts (HSAs)',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'hsaSavingsAccountModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.hsaSavingsAccounts(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.HsaSavingsAccountsModal, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.hsaSavingsAccountsClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.hsaSavingsAccountsOpen
    })
  }, {
    name: 'Tax planning strategies',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'taxPlanningStrategiesPlanninngForRetirementModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.taxPlanningStrategiesRetirement(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.TaxPlanningStrategiesModalForRetirement, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.taxPlanningStrategiesRetirementClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.taxPlanningStrategiesRetirementOpen
    })
  }, {
    name: 'Tax planning strategies',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'taxPlanningStrategiesBuildWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.taxPlanningStrategiesWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.TaxPlanningStrategiesModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.taxPlanningStrategiesWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.taxPlanningStrategiesWealthOpen
    })
  }, {
    name: 'Estate planning services',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'estatePlanningServicesTransitioningWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.estatePlanningServicesWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.EstatePlanningServicesModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.estatePlanningServicesWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.estatePlanningServicesWealthOpen
    })
  }, {
    name: 'Estate planning services',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'estatePlanningServicesEnsureFamilySecuredModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.estatePlanningServicesFamilySecured(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.EstatePlanningServicesModalForFamilySecured, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.estatePlanningServicesFamilySecuredClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.estatePlanningServicesFamilySecuredOpen
    })
  }, {
    name: 'Trust services',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'trustServicesTransitioningWealthModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.trustServicesWealth(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.TrustServicesModalForWealth, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.trustServicesWealthClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.trustServicesWealthOpen
    })
  }, {
    name: 'Trust services',
    /* istanbul ignore next */
    modalOpenHandler: () => {
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'trustServicesEnsureFamilySecuredModal');
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.trustServicesFamilySecured(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.TrustServicesModalForFamilySecured, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.trustServicesFamilySecuredClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.trustServicesFamilySecuredOpen
    })
  }, {
    name: 'Savings account',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'savingsAccountModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.savingsAccount(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.SavingsAccountModal, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.savingsAccountClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.savingsAccountOpen
    })
  }, {
    name: 'Other investments',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'otherInvestmentsModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.otherInvestments(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.OtherInvestmentstModal, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.otherInvestmentsClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.otherInvestmentsOpen
    })
  }, {
    name: 'Education savings account',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'educationalSavingsModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.educationalSavings(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.EducationalSavingsModal, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.educationalSavingsClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.educationalSavingsOpen
    })
  }, {
    name: 'Disability insurance',
    modalOpenHandler: () => {
      // istanbul ignore next
      (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'disabilityInsuranceModal');
      // istanbul ignore next
      setModalOpen === null || setModalOpen === void 0 || setModalOpen.disabilityInsurance(true);
    },
    modalComponent: /*#__PURE__*/_react.default.createElement(_FPCTModals.DisabilityInsuranceModal, {
      handleClose: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.disabilityInsuranceClose,
      show: setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen.disabilityInsuranceOpen
    })
  }];
  var addGoalData = (icon, goal, currentSolutions, additionalSolutions) => {
    return {
      currentPlan: [{
        icon,
        goal,
        solution: currentSolutions.map(solution => ({
          solution: solution.name
        }))
      }],
      optimizedPlan: [{
        icon,
        goal,
        solution: currentSolutions.map(solution => ({
          solution: solution.name
        })),
        explore: additionalSolutions.map(solution2 => ({
          solution: solution2.name
        }))
      }]
    };
  };
  if (values.isPlanningRetirementGoal) {
    var currentSolutions = [];
    var additionalSolutions = [];
    var investmentOptionsSelected = [values.hasMoneyMarketCD, values.hasStocks, values.hasBonds, values.hasMutualFunds, values.hasETFs, values.hasOtherInvestments].some(Boolean);
    var retirementAccountsSelected = [values.has401k, values.has403b, values.has457, values.hasIRA, values.hasPension].some(Boolean);
    var annuitySelected = [values.hasAnnuity].some(Boolean);
    var lifeInsuranceSelected = [values.hasLifeInsurance].some(Boolean);
    var longTermCareSelected = [values.hasLTCProtection].some(Boolean);
    var hsaSavingsAccountsSelected = [values.hasHealthSavingsAccount].some(Boolean);
    var taxPlanningStrategiesSelected = [values.hasTaxPlanning].some(Boolean);
    if (investmentOptionsSelected) {
      currentSolutions.push(solutions[0]);
    } else {
      additionalSolutions.push(solutions[0]);
    }
    if (retirementAccountsSelected) {
      currentSolutions.push(solutions[4]);
    } else {
      additionalSolutions.push(solutions[4]);
    }
    if (annuitySelected) {
      currentSolutions.push(solutions[6]);
    } else {
      additionalSolutions.push(solutions[6]);
    }
    if (lifeInsuranceSelected) {
      currentSolutions.push(solutions[9]);
    } else {
      additionalSolutions.push(solutions[9]);
    }
    if (longTermCareSelected) {
      currentSolutions.push(solutions[13]);
    } else {
      additionalSolutions.push(solutions[13]);
    }
    if (hsaSavingsAccountsSelected) {
      currentSolutions.push(solutions[15]);
    } else {
      additionalSolutions.push(solutions[15]);
    }
    if (taxPlanningStrategiesSelected) {
      currentSolutions.push(solutions[16]);
    } else {
      additionalSolutions.push(solutions[16]);
    }
    goalArray.push(renderGoal('Plan for and live a comfortable retirement', 'Sailboat', currentSolutions, additionalSolutions));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(additionalSolutions);
    goalDataArray.push(addGoalData('icon-t2-sailboat', 'Plan for and live a comfortable retirement', currentSolutions, additionalSolutions));
  }
  if (values.isTransitioningWealthGoal) {
    var _currentSolutions = [];
    var _additionalSolutions = [];
    var estatePlanningServicesSelected = [values.hasEstatePlanningServices].some(Boolean);
    var trustServicesSelected = [values.hasTrustServices].some(Boolean);
    var _lifeInsuranceSelected = [values.hasLifeInsurance].some(Boolean);
    if (estatePlanningServicesSelected) {
      _currentSolutions.push(solutions[18]);
    } else {
      _additionalSolutions.push(solutions[18]);
    }
    if (trustServicesSelected) {
      _currentSolutions.push(solutions[20]);
    } else {
      _additionalSolutions.push(solutions[20]);
    }
    if (_lifeInsuranceSelected) {
      _currentSolutions.push(solutions[10]);
    } else {
      _additionalSolutions.push(solutions[10]);
    }
    goalArray.push(renderGoal('Transition wealth', 'HandsDollarSign', _currentSolutions, _additionalSolutions));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(_additionalSolutions);
    goalDataArray.push(addGoalData('icon-t2-hands-dollar-sign', 'Transition wealth', _currentSolutions, _additionalSolutions));
  }
  if (values.isSavingForMajorPurchaseGoal) {
    var _currentSolutions2 = [];
    var _additionalSolutions2 = [];
    var savingsAccountSelected = [values.hasSavingsAccount].some(Boolean);
    var _investmentOptionsSelected = [values.hasMoneyMarketCD, values.hasStocks, values.hasBonds, values.hasMutualFunds, values.hasETFs, values.hasOtherInvestments].some(Boolean);
    if (_investmentOptionsSelected) {
      _currentSolutions2.push(solutions[1]);
    } else {
      _additionalSolutions2.push(solutions[1]);
    }
    if (savingsAccountSelected) {
      _currentSolutions2.push(solutions[22]);
    } else {
      _additionalSolutions2.push(solutions[22]);
    }
    goalArray.push(renderGoal('Save for a major purchase', 'House', _currentSolutions2, _additionalSolutions2));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(_additionalSolutions2);
    goalDataArray.push(addGoalData('icon-t2-house', 'Save for a major purchase', _currentSolutions2, _additionalSolutions2));
  }
  if (values.isBuildWealthGoal) {
    var _currentSolutions3 = [];
    var _additionalSolutions3 = [];
    var _investmentOptionsSelected2 = [values.hasMoneyMarketCD, values.hasStocks, values.hasBonds, values.hasMutualFunds, values.hasETFs, values.hasOtherInvestments].some(Boolean);
    var _retirementAccountsSelected = [values.has401k, values.has403b, values.has457, values.hasIRA, values.hasPension].some(Boolean);
    var _annuitySelected = [values.hasAnnuity].some(Boolean);
    var otherInvestmentsSelected = [values.hasOtherInvestments].some(Boolean);
    var _taxPlanningStrategiesSelected = [values.hasTaxPlanning].some(Boolean);
    if (_investmentOptionsSelected2) {
      _currentSolutions3.push(solutions[2]);
    } else {
      _additionalSolutions3.push(solutions[2]);
    }
    if (_retirementAccountsSelected) {
      _currentSolutions3.push(solutions[5]);
    } else {
      _additionalSolutions3.push(solutions[5]);
    }
    if (_annuitySelected) {
      _currentSolutions3.push(solutions[7]);
    } else {
      _additionalSolutions3.push(solutions[7]);
    }
    if (otherInvestmentsSelected) {
      _currentSolutions3.push(solutions[23]);
    } else {
      _additionalSolutions3.push(solutions[23]);
    }
    if (_taxPlanningStrategiesSelected) {
      _currentSolutions3.push(solutions[17]);
    } else {
      _additionalSolutions3.push(solutions[17]);
    }
    goalArray.push(renderGoal('Build wealth/maximize my investments', 'BarUpChart', _currentSolutions3, _additionalSolutions3));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(_additionalSolutions3);
    goalDataArray.push(addGoalData('icon-t2-bar-chart-up', 'Build wealth/maximize my investments', _currentSolutions3, _additionalSolutions3));
  }
  if (values.isSavingForEducationExpensesGoal) {
    var _currentSolutions4 = [];
    var _additionalSolutions4 = [];
    var educationalSavingsSelected = [values.hasEducationSavingsAccount].some(Boolean);
    var _investmentOptionsSelected3 = [values.hasMoneyMarketCD, values.hasStocks, values.hasBonds, values.hasMutualFunds, values.hasETFs, values.hasOtherInvestments].some(Boolean);
    var _lifeInsuranceSelected2 = [values.hasLifeInsurance].some(Boolean);
    if (educationalSavingsSelected) {
      _currentSolutions4.push(solutions[24]);
    } else {
      _additionalSolutions4.push(solutions[24]);
    }
    if (_investmentOptionsSelected3) {
      _currentSolutions4.push(solutions[3]);
    } else {
      _additionalSolutions4.push(solutions[3]);
    }
    if (_lifeInsuranceSelected2) {
      _currentSolutions4.push(solutions[11]);
    } else {
      _additionalSolutions4.push(solutions[11]);
    }
    goalArray.push(renderGoal('Save for education expenses', 'Graduate', _currentSolutions4, _additionalSolutions4));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(_additionalSolutions4);
    goalDataArray.push(addGoalData('icon-t2-graduate', 'Save for education expenses', _currentSolutions4, _additionalSolutions4));
  }
  if (values.isFamilyFinanciallySecureGoal) {
    var _currentSolutions5 = [];
    var _additionalSolutions5 = [];
    var _lifeInsuranceSelected3 = [values.hasLifeInsurance].some(Boolean);
    var _longTermCareSelected = [values.hasLTCProtection].some(Boolean);
    var disabilityInsuranceSelected = [values.hasDisabilityIncomeInsurance].some(Boolean);
    var _estatePlanningServicesSelected = [values.hasEstatePlanningServices].some(Boolean);
    var _trustServicesSelected = [values.hasTrustServices].some(Boolean);
    var _annuitySelected2 = [values.hasAnnuity].some(Boolean);
    if (_lifeInsuranceSelected3) {
      _currentSolutions5.push(solutions[12]);
    } else {
      _additionalSolutions5.push(solutions[12]);
    }
    if (_longTermCareSelected) {
      _currentSolutions5.push(solutions[14]);
    } else {
      _additionalSolutions5.push(solutions[14]);
    }
    if (disabilityInsuranceSelected) {
      _currentSolutions5.push(solutions[25]);
    } else {
      _additionalSolutions5.push(solutions[25]);
    }
    if (_estatePlanningServicesSelected) {
      _currentSolutions5.push(solutions[19]);
    } else {
      _additionalSolutions5.push(solutions[19]);
    }
    if (_trustServicesSelected) {
      _currentSolutions5.push(solutions[21]);
    } else {
      _additionalSolutions5.push(solutions[21]);
    }
    if (_annuitySelected2) {
      _currentSolutions5.push(solutions[8]);
    } else {
      _additionalSolutions5.push(solutions[8]);
    }
    goalArray.push(renderGoal('Ensure my family is financially secure', 'Shield', _currentSolutions5, _additionalSolutions5));
    masterAdditionalSolutions = masterAdditionalSolutions.concat(_additionalSolutions5);
    goalDataArray.push(addGoalData('icon-t2-shield-dollar-sign-2', 'Ensure my family is financially secure', _currentSolutions5, _additionalSolutions5));
  }
  masterAdditionalSolutions = (0, _lodash.map)(masterAdditionalSolutions, solution => solution.name);
  masterAdditionalSolutions = (0, _lodash.uniq)(masterAdditionalSolutions);
  if (columnType === 'optimized') values.productsSuggestedList = masterAdditionalSolutions;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, goalArray.map((goal, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, goal, index < goalArray.length - 1 && /*#__PURE__*/_react.default.createElement("hr", null))));
}
function CalculatePlanMessage(_ref3) {
  var {
    values,
    setFieldValue
  } = _ref3;
  var {
    hasEstatePlanningServices,
    hasTrustServices,
    hasTaxPlanning,
    hasRetirementPlanning,
    hasSavingsAccount,
    hasHealthSavingsAccount,
    hasEducationSavingsAccount,
    hasLifeInsurance,
    hasLTCProtection,
    hasDisabilityIncomeInsurance,
    has401k,
    has403b,
    has457,
    hasIRA,
    hasPension,
    hasAnnuity,
    hasMoneyMarketCD,
    hasStocks,
    hasBonds,
    hasMutualFunds,
    hasETFs,
    hasOtherInvestments
  } = values;
  var selectedCheckboxes = [hasEstatePlanningServices, hasTrustServices, hasTaxPlanning, hasRetirementPlanning, hasSavingsAccount, hasHealthSavingsAccount, hasEducationSavingsAccount, hasLifeInsurance, hasLTCProtection, hasDisabilityIncomeInsurance, has401k, has403b, has457, hasIRA, hasPension, hasAnnuity, hasMoneyMarketCD, hasStocks, hasBonds, hasMutualFunds, hasETFs, hasOtherInvestments];
  var goalToCheckboxesMap = {
    isPlanningRetirementGoal: {
      required: [hasAnnuity, hasLifeInsurance, hasLTCProtection, hasHealthSavingsAccount, hasTaxPlanning],
      investmentSolutions: [hasMoneyMarketCD, hasStocks, hasBonds, hasMutualFunds, hasETFs, hasOtherInvestments],
      retirementAccounts: [has401k, has403b, has457, hasIRA, hasPension]
    },
    isTransitioningWealthGoal: {
      required: [hasEstatePlanningServices, hasTrustServices, hasLifeInsurance]
    },
    isSavingForMajorPurchaseGoal: {
      required: [hasSavingsAccount],
      investmentSolutions: [hasMoneyMarketCD, hasStocks, hasBonds, hasMutualFunds, hasETFs, hasOtherInvestments]
    },
    isBuildWealthGoal: {
      required: [hasAnnuity, hasOtherInvestments, hasTaxPlanning],
      investmentSolutions: [hasMoneyMarketCD, hasStocks, hasBonds, hasMutualFunds, hasETFs, hasOtherInvestments],
      retirementAccounts: [has401k, has403b, has457, hasIRA, hasPension]
    },
    isSavingForEducationExpensesGoal: {
      required: [hasEducationSavingsAccount, hasLifeInsurance],
      investmentSolutions: [hasMoneyMarketCD, hasStocks, hasBonds, hasMutualFunds, hasETFs, hasOtherInvestments]
    },
    isFamilyFinanciallySecureGoal: {
      required: [hasLifeInsurance, hasLTCProtection, hasDisabilityIncomeInsurance, hasEstatePlanningServices, hasTrustServices, hasAnnuity]
    }
  };
  var selectedGoals = Object.keys(goalToCheckboxesMap).filter(goal => values[goal]);
  var relevantCheckboxes = selectedGoals.flatMap(goal => [...goalToCheckboxesMap[goal].required, ...(goalToCheckboxesMap[goal].investmentSolutions || []), ...(goalToCheckboxesMap[goal].retirementAccounts || [])]);
  var selectedRelevantCheckboxes = relevantCheckboxes.filter(Boolean).length;
  var selectedCount = selectedCheckboxes.filter(Boolean).length;
  var totalCheckboxes = selectedCheckboxes.length;
  var hasAllRelevantForGoal = goal => {
    var {
      required,
      investmentSolutions,
      retirementAccounts
    } = goalToCheckboxesMap[goal];
    return required.every(Boolean) && (investmentSolutions ? investmentSolutions.some(Boolean) : true) && (retirementAccounts ? retirementAccounts.some(Boolean) : true);
  };
  var displayPlanTitleText = '';
  var displayPlanContentText = '';
  var displayPlanIcon = '';
  var rightPathScenarioText = "Now that you've identified your goals and assessed your current plan, here are additional products and services that may help you better reach the future you envision.";
  var zeroSolutionsScenarioText = "We know this suite of solutions may feel overwhelming. Our network of financial professionals can help you sort through it and determine which options may be best for you.";
  var planHasAllSolutionsScenarioText = "Great job! By discussing your current approach with a financial professional you may be able to find opportunities to refine your strategy.";
  if (selectedCount === 0) {
    displayPlanTitleText = "You've got this and we're here to help";
    displayPlanContentText = zeroSolutionsScenarioText;
    displayPlanIcon = 'icon-info';
  } else if (selectedCount === totalCheckboxes) {
    displayPlanTitleText = "You're on the right path";
    displayPlanContentText = planHasAllSolutionsScenarioText;
    displayPlanIcon = 'icon-answer-correct';
  } else if (selectedGoals.every(hasAllRelevantForGoal)) {
    displayPlanTitleText = "You're on the right path";
    displayPlanContentText = planHasAllSolutionsScenarioText;
    displayPlanIcon = 'icon-answer-correct';
  } else if (selectedRelevantCheckboxes === relevantCheckboxes.length) {
    displayPlanTitleText = "You're on the right path";
    displayPlanContentText = planHasAllSolutionsScenarioText;
    displayPlanIcon = 'icon-answer-correct';
  } else if (selectedRelevantCheckboxes === 0) {
    displayPlanTitleText = "You've got this and we're here to help";
    displayPlanContentText = zeroSolutionsScenarioText;
    displayPlanIcon = 'icon-info';
  } else {
    displayPlanTitleText = "You're on the right path";
    displayPlanContentText = rightPathScenarioText;
    displayPlanIcon = 'icon-answer-correct';
  }
  (0, _react.useEffect)(() => {
    setFieldValue('displayPlanTitleText', displayPlanTitleText);
    setFieldValue('displayPlanContentText', displayPlanContentText);
    setFieldValue('displayPlanIcon', displayPlanIcon);
  }, [displayPlanTitleText, displayPlanContentText, displayPlanIcon]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-auto analysis-message-icon"
  }, selectedCount > 0 && selectedRelevantCheckboxes > 0 ? /*#__PURE__*/_react.default.createElement(_ThumbsUp.default, null) : /*#__PURE__*/_react.default.createElement(_AlertIcon.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "col no-padding"
  }, /*#__PURE__*/_react.default.createElement("strong", null, displayPlanTitleText), /*#__PURE__*/_react.default.createElement("br", null), displayPlanContentText)));
}